import React, { useState, useEffect } from 'react';
import cs from "./style.module.css";
import logo from "./images/accesslogo.png";
import dataIcon from "./images/dash.png";
import AllComponent from './AllComponent';
import Hendrick from './Hendrick';
import Rimon from './Rimon';
import Jennie from './Jennie';
import Kevin from './Kevin';
import Bridged from './Bridged';
import { ToastContainer } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import Consolidated from './Consolidated';


const Main = () => {
  const TOP_OFFSET = 50;
  const [showBackground, setShowBackground] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      // console.log(window.scrollY);
      if (window.scrollY >= TOP_OFFSET) {
        setShowBackground(true);
      } else {
        setShowBackground(false);
      }
    };
  }, []);
  const [loggedInUsername, setLoggedInUsername] = useState('');
  const username = localStorage.getItem('username');
  useEffect(()=>{
    setLoggedInUsername(username);
  },[username])
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('token');
  const handleLogout = () => {
    localStorage.removeItem('token'); // Clear token from localStorage on logout
    navigate('/login');
    };
  const [hendrickTab, setHendrickTab] = useState(false);
  const [dashTab, setDashTab] = useState(false);
  const [rimonTab, setRimonTab] = useState(false);
  const [jennieTab, setJennieTab] = useState(false);
  const [kevinTab, setKevinTab] = useState(false);
  const [bridgedTab, setBridgedTab] = useState(false);
  const [consolidateTab, setConsolidateTab] = useState(false);
  let handledash = ()=>{
    setDashTab(true);
    setHendrickTab(false);
    setRimonTab(false);
    setJennieTab(false);
    setKevinTab(false);
    setConsolidateTab(false);
    setBridgedTab(false);
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
  let handleHendrick = ()=>{
    setDashTab(false);
    setHendrickTab(true);
    setRimonTab(false);
    setJennieTab(false);
    setKevinTab(false);
    setConsolidateTab(false);
    setBridgedTab(false);
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
  let handleRimon = ()=>{
    setDashTab(false);
    setHendrickTab(false);
    setRimonTab(true);
    setJennieTab(false);
    setKevinTab(false);
    setConsolidateTab(false);
    setBridgedTab(false);
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
  let handleJennie = ()=>{
    setDashTab(false);
    setHendrickTab(false);
    setRimonTab(false);
    setJennieTab(true);
    setKevinTab(false);
    setConsolidateTab(false);
    setBridgedTab(false);
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
  let handleKevin = ()=>{
    setDashTab(false);
    setHendrickTab(false);
    setRimonTab(false);
    setJennieTab(false);
    setKevinTab(true);
    setConsolidateTab(false);
    setBridgedTab(false);
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
  let handleBridged = ()=>{
    setDashTab(false);
    setHendrickTab(false);
    setRimonTab(false);
    setJennieTab(false);
    setKevinTab(false);
    setConsolidateTab(false);
    setBridgedTab(true);
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
  let handleConsolidate = ()=>{
    setDashTab(false);
    setHendrickTab(false);
    setRimonTab(false);
    setJennieTab(false);
    setKevinTab(false);
    setBridgedTab(false);
    setConsolidateTab(true);
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  let AllTabs = (items)=>{
    if(dashTab){
      return <AllComponent />
    }
    else if(hendrickTab){
      return <Hendrick />
    }
    else if(rimonTab){
      return <Rimon />
    }
    else if(jennieTab){
      return <Jennie />
    }
    else if(kevinTab){
      return <Kevin />
    }
    else if(bridgedTab){
      return <Bridged />
    }
    else if(consolidateTab){
      return <Consolidated />
    }else{
      return <AllComponent />
    }
  }
  return (
    <div className='w-full h-full flex md:justify-between md:flex-row flex-col items-start relative'>
      <div className={`md:w-[20%] w-full h-screen bg-white md:sticky md:top-0 backdrop-filter backdrop-blur-sm bg-opacity-30 p-8 flex justify-between items-start flex-col`}>
          <div className='w-full h-auto'>
                <a href="#"><img src={logo} width={150} alt="Access Intel" /></a>
              <div className='w-full h-auto flex justify-start items-start flex-col bg-white backdrop-filter backdrop-blur-sm bg-opacity-60 p-6 rounded-md mt-8'>
              <div onClick={handledash} className='w-full h-auto flex justify-evenly cursor-pointer items-center bg-black text-white rounded-md py-2'>
                <img src={dataIcon} width={25} alt="icon" />
                <h1 className='text-lg font-bold'>Dashboard</h1>
              </div>
              <div onClick={handleHendrick} className={`w-full h-auto flex justify-between cursor-pointer items-center hover:bg-blue-500 border-b-2 border-gray-300 hover:text-white transition-all duration-300 text-black mt-5 rounded-md py-2 px-5 ${cs.bshadow} ${hendrickTab == true ? 'bg-blue-700 text-white' : ''}`}>
                <h1 className='text-lg'>Hendrick</h1>
                <h1 className='text-lg '>&#10148;</h1>
              </div>
              <div onClick={handleRimon} className={`w-full h-auto flex justify-between cursor-pointer items-center hover:bg-blue-500 border-b-2 border-gray-300 hover:text-white transition-all duration-300 text-black rounded-md mt-4 py-2 px-5 ${cs.bshadow} ${rimonTab == true ? 'bg-blue-700 text-white' : ''}`}>
                <h1 className='text-lg'>Rimon</h1>
                <h1 className='text-lg '>&#10148;</h1>
              </div>
              <div onClick={handleJennie} className={`w-full h-auto flex justify-between cursor-pointer items-center hover:bg-blue-500 border-b-2 border-gray-300 hover:text-white transition-all duration-300 text-black rounded-md mt-4 py-2 px-5 ${cs.bshadow} ${jennieTab == true ? 'bg-blue-700 text-white' : ''}`}>
                <h1 className='text-lg'>Jennie</h1>
                <h1 className='text-lg '>&#10148;</h1>
              </div>
              <div onClick={handleKevin} className={`w-full h-auto flex justify-between cursor-pointer items-center hover:bg-blue-500 border-b-2 border-gray-300 hover:text-white transition-all duration-300 text-black rounded-md mt-4 py-2 px-5 ${cs.bshadow} ${kevinTab == true ? 'bg-blue-700 text-white' : ''}`}>
                <h1 className='text-lg'>Kevin</h1>
                <h1 className='text-lg '>&#10148;</h1>
              </div>
              <div onClick={handleBridged} className={`w-full h-auto flex justify-between cursor-pointer items-center hover:bg-blue-500 border-b-2 border-gray-300 hover:text-white transition-all duration-300 text-black rounded-md mt-4 py-2 px-5 ${cs.bshadow} ${bridgedTab == true ? 'bg-blue-700 text-white' : ''}`}>
                <h1 className='text-lg'>Bridget</h1>
                <h1 className='text-lg '>&#10148;</h1>
              </div>
              <div onClick={handleConsolidate} className={`w-full h-auto flex justify-between cursor-pointer items-center hover:bg-blue-500 border-b-2 border-gray-300 hover:text-white transition-all duration-300 text-black rounded-md mt-4 py-2 px-5 ${cs.bshadow} ${consolidateTab == true ? 'bg-blue-700 text-white' : ''}`}>
                <h1 className='text-lg'>Consolidate</h1>
                <h1 className='text-lg '>&#10148;</h1>
              </div>
              </div>
          </div>
      </div>
      <div className={`md:w-[80%] w-full backdrop-filter backdrop-blur-sm bg-opacity-30 h-full flex justify-center items-start flex-col`}>
        <div className='w-full h-auto md:p-8 p-4 relative md:pt-0'>
          <div className={`w-full h-auto flex justify-between items-center sticky top-0 md:mt-8 z-10 ${showBackground ? "bg-white backdrop-filter backdrop-blur-sm bg-opacity-80 p-4" : ""}`}>
            <h1 className='md:text-2xl text-md font-bold text-left'>Sub User Management</h1>
            <div className='w-auto h-auto flex justify-center items-center'>
              <h1 className='text-lg'>Hello <span className='text-blue-700'>{loggedInUsername === "admin" ? "SpanGlobal Services" : "Access Intel"}</span></h1>
              {isLoggedIn ? (
              <button onClick={handleLogout} className='bg-red-600 text-sm cursor-pointer px-2 py-1 ml-2 text-white rounded-sm'>Logout</button>
              ) : (
              <Link to={'/login'}><button className='bg-blue-600 text-sm cursor-pointer px-2 py-1 ml-2 text-white rounded-sm'>Login</button></Link>
              )}
              
            </div>
          </div>
              <AllTabs items ={true}/>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default Main;
